export function loadCustomerIO() {
  const siteId = import.meta.env.VITE_CUSTOMER_IO_SITE_ID;
  if (!siteId) {
    console.error('[CustomerIO] Site ID is missing!');
    return;
  }

  // Initialize _cio early
  (window as any)._cio = (window as any)._cio || [];
  const _cio = (window as any)._cio;

  // Define _cio methods
  const methods = ['load', 'identify', 'sidentify', 'track', 'page', 'on', 'off'];
  methods.forEach((method) => {
    _cio[method] = function (...args: any[]) {
      _cio.push([method, ...args]);
    };
  });

  // Create Customer.io script tag
  const script = document.createElement('script');
  script.async = true;
  script.id = 'cio-tracker';
  script.setAttribute('data-site-id', siteId);
  script.setAttribute('data-use-array-params', 'true');
  script.setAttribute('data-use-in-app', 'true');
  script.src = 'https://assets.customer.io/assets/track-eu.js';

  document.head.appendChild(script);

  console.log('[CustomerIO] Loading...');
}
